import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { AccountingSystemEnums } from 'src/app/enum/accouting-system-enums';
import { GeneralParameterEnums } from 'src/app/enum/general-parameter-enums';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CompanyModel } from 'src/app/models/management/company.model';
import { UserService } from 'src/app/services/authentication/user.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { GeneralParameterService } from 'src/app/services/management/general-parameter.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { AdvancedOptionsCompanyComponent } from '../advanced-options-company/advanced-options-company.component';
import { DeleteCompanyComponent } from '../delete-company/delete-company.component';
import { GeneralParameterComponent } from '../general-parameter/general-parameter.component';
import { MandatorComponent } from '../mandator/mandator.component';
import { PermissionsCompanyComponent } from '../permissions-company/permissions-company.component';

@Component({
  selector: 'app-register-company',
  templateUrl: './register-company.component.html',
  styleUrls: ['./register-company.component.scss'],
  standalone: false
})
export class RegisterCompanyComponent implements OnInit {

  @ViewChild('generalParameterModal') generalParameterModalComponent?: CustomModalComponent | null = null;
  @ViewChild('advancedOptions') advancedOptionsModalComponent?: CustomModalComponent | null = null;
  @ViewChild('permissionsCompanyModal') permissionsCompanyModalComponent?: CustomModalComponent | null = null;
  @ViewChild('deleteCompany') deleteCompanyModalComponent?: CustomModalComponent | null = null;
  @ViewChild('mandatorModal') mandatorModalComponent?: CustomModalComponent | null = null;

  formCompany: FormGroup = new FormGroup({});
  swAdvanceInvoice: boolean = false;
  companyContract: CompanyModel = new CompanyModel();
  companyId: number = 0;
  url: string = 'company';
  nameWindow: string = 'Captura Compañías';
  projectName = ProjectName.projectName;
  isOpened: string | undefined = undefined;
  permissionUpdatable: boolean = false;
  isPrincipalCompany: boolean = false;
  isASADMIN: boolean = false;
  componentGeneralParameterModal = GeneralParameterComponent;
  componentAdvancedOptions = AdvancedOptionsCompanyComponent;
  componentPermissionsCompany = PermissionsCompanyComponent;
  componentMandator = MandatorComponent;
  componentDeleteCompany = DeleteCompanyComponent;
  inputsForDeleteCompanyModals$ = new BehaviorSubject<any>({
    companyId: 0,
  });
  inputsForPermissionsCompanyModals$ = new BehaviorSubject<any>({
    companyId: 0,
    disabledForm: false
  });
  inputsForMandatorModals$ = new BehaviorSubject<any>({
    companyId: 0,
    disabledForm: false
  });
  inputsForGeneralParameterModals$ = new BehaviorSubject<any>({
    companyId: 0,
    disabledButton: false
  });
  inputsForAdvancedOptionsModals$ = new BehaviorSubject<any>({
    companyContract: new CompanyModel(),
    permissionUpdatable: false,
    disabledForm: false,
    swAdvanceInvoice: false,
    listArticles: [],
    listConceptInvoicing: [],
    listCurrency: [],
    listCountry: [],
  });
  visibleHelissaNiif: boolean = false;
  visibleIlimitada: boolean = false;
  listAccountingSystem: CustomListDropdown[] = [];
  listArticles: CustomListDropdown[] = [];
  listTypeDocuments: CustomListDropdown[] = [];
  listTypeAccountingSystems: CustomListDropdown[] = [];
  listConceptInvoicing: CustomListDropdown[] = [];
  listCurrency: CustomListDropdown[] = [];
  listCountry: CustomListDropdown[] = [];
  disabledForm: boolean = false;
  titleState: string = '';
  severityState: string = 'success';
  siesaCloud: number = AccountingSystemEnums.siesaCloud
  stateCompany: string = '';
  icon: string = '';

  constructor(private activatedRoute: ActivatedRoute,
    private companyService: CompanyService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private generalParameterService: GeneralParameterService,
    private toastHandlerService: ToastHandlerService,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private formControlStateService: FormControlStateService,
    private userService: UserService,
    private windowService: WindowService) {
    this.validateForm(new CompanyModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.companyId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  addDefaultOption(typeAccountingSystems: CustomListDropdown[]): CustomListDropdown[] {
    return [...typeAccountingSystems, { label: 'Ninguno', value: null }];
  }

  changeTypeAccountingSystem(typeAccountingSystemId: number | null, accountingSystemId: number | null) {
    const control = this.formCompany.controls['accountingSystemId'];
    if (accountingSystemId) {
      this.getAccountingSystem(accountingSystemId);
      return;
    }
    this.getAccountingSystem();
    if (!typeAccountingSystemId) {
      control.patchValue(null);
      control.disable();
      return;
    }
    control.enable();
  }

  async changeCode(code: number) {
    if (!code) {
      this.resetContract();
    } else {
      await this.getCompanyByCode(code);
    }
  }

  async changeStateCompany() {
    const { companyId } = this.companyContract;
    if (!companyId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una compañía.');
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado de la compañía.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    try {
      const response = await firstValueFrom(this.companyService.setActiveCompany(companyId));
      this.companyContract = response;
      this.validateForm(this.companyContract);
      const successMessage = response.active ? 'La compañía fue activada exitosamente.'
        : 'La compañía fue desactivada exitosamente.'
      this.toastHandlerService.showToast('success', successMessage);
    } catch (error) {
      console.error('Error al cambiar el estado de la compañía.', error);
    }
  }

  async createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear compañías.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    this.resetContract();
  }

  async createCompany(modelcompany: CompanyModel) {
    try {
      const response = await firstValueFrom(this.companyService.createCompany(modelcompany));
      this.companyContract = response;
      this.companyId = response.companyId;
      this.validateForm(this.companyContract);
      this.location.replaceState(`/${this.url}/register/${this.companyId}`);
      this.toastHandlerService.showToast('success', `La compañía fue creada exitosamente.`);
    } catch (error) {
      console.error('Error al crear la compañía.', error);
    }
  }

  async getAllLists(...listsToLoad: Array<'articles' | 'accountingSystems' | 'conceptInvoicings' | 'countries' |
    'currencies' | 'typeAccountingSystems' | 'typeDocuments'>) {
    try {
      const lists = {
        accountingSystems: async () => {
          this.listAccountingSystem = await firstValueFrom(
            this.companyService.getAllAccountingSystemsForSelect()
          );
        },
        articles: async () => {
          if (this.companyId) {
            this.listArticles = await firstValueFrom(
              this.companyService.getAllArticlesByCompanyIdForSelect(this.companyId)
            );
          }
        },
        conceptInvoicings: async () => {
          if (this.companyId) {
            this.listConceptInvoicing = await firstValueFrom(
              this.companyService.getAllConceptInvoicingsForSelect(this.companyId)
            );
          }
        },
        countries: async () => {
          this.listCountry = await firstValueFrom(
            this.companyService.getAllCountriesForSelect()
          );
        },
        currencies: async () => {
          this.listCurrency = await firstValueFrom(
            this.companyService.getAllCurrenciesForSelect()
          );
        },
        typeAccountingSystems: async () => {
          const typeAccountingSystems = await firstValueFrom(
            this.companyService.getAllTypeAccountingSystemsForSelect()
          );
          this.listTypeAccountingSystems = this.addDefaultOption(typeAccountingSystems);
        },
        typeDocuments: async () => {
          this.listTypeDocuments = await firstValueFrom(
            this.companyService.getAllTypeDocumentsForSelect()
          );
        }
      };

      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.accountingSystems(),
          lists.articles(),
          lists.conceptInvoicings(),
          lists.countries(),
          lists.currencies(),
          lists.typeAccountingSystems(),
          lists.typeDocuments(),
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  getAccountingSystem(accountingSystemId?: number) {
    this.visibleIlimitada = false;
    this.visibleHelissaNiif = false;
    switch (accountingSystemId) {
      case AccountingSystemEnums.helisa: {
        this.visibleHelissaNiif = true;
        break;
      }
      case AccountingSystemEnums.ilimitada: {
        this.visibleIlimitada = true;
        break;
      }
    }
  }

  async getButtonClick(buttonClick: any) {
    await this.handleCompanyNavigation(buttonClick)
  }

  async getCompanyByCode(code: number) {
    try {
      const response = await firstValueFrom(this.companyService.getCompanyByCode(code));
      this.companyId = response.companyId;
      this.companyContract = response;
      await this.getAllLists('articles', 'conceptInvoicings');
      this.validateForm(this.companyContract);
    } catch (error) {
      console.error('Error al obtnener la compañia por código.', error);
    }
  }

  async getCompanyById() {
    try {
      const response = await firstValueFrom(this.companyService.getCompanyById(this.companyId));
      this.companyContract = response;
      this.validateForm(this.companyContract);
    } catch (error) {
      console.error('Error al obtener la compañía por id.', error);
    }
  }

  async getDigitVerification(document: string) {
    if (!document) {
      this.formCompany.controls["digitVerification"].setValue(-1);
      this.toastHandlerService.showToast('error', 'El documento ingresado no es válido.');
    } else {
      try {
        const response = await firstValueFrom(this.companyService.getDigitVerification(document));
        this.formCompany.controls["digitVerification"].setValue(response);
      } catch (error) {
        this.formCompany.controls["digitVerification"].setValue(-1);
        console.error('Error al obtnener el digito de verification.', error);
      }
    }
  }

  async getGeneralParameter() {
    if (this.companyId != null && this.companyId != 0) {
      try {
        const response = await firstValueFrom(this.generalParameterService.getGeneralParametersByCompany(this.companyId));
        this.swAdvanceInvoice = response.find(x => x.generalParameterId == GeneralParameterEnums.facturaAnticipada) != null;
      } catch (error) {
        console.error('Error al obtener parámetros generales:', error);
      }
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await this.getGeneralParameter();
    await this.getAllLists();
    await this.getUserPermissions();
  }

  async getUserPermissions() {
    await Promise.all([
      this.userAuthenticatedIsASADMIN(),
      this.userAuthenticatedIsPrincipalCompany(),
    ]);

    if (this.isASADMIN) {
      this.permissionUpdatable = true;
    } else {
      await this.getPermissionProfileByUrl();
    }
  }

  async getPermissionProfileByUrl() {
    try {
      const response = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.permissionUpdatable = response;
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.companyId) {
      await this.getCompanyById();
    } else {
      this.createNewRegister();
    }
  }

  async handleCompanyNavigation(buttonClick: any) {
    const code = this.formCompany.get("code")?.value;
    const actionMap: Record<string, () => Promise<CompanyModel>> = {
      first: () =>
        firstValueFrom(this.companyService.getFirstCompanyByKeysAsync()),
      previus: () =>
        firstValueFrom(this.companyService.getPreviusCompanyByKeysAsync(code)),
      next: () =>
        firstValueFrom(this.companyService.getNextCompanyByKeysAsync(code)),
      last: () =>
        firstValueFrom(this.companyService.getLastCompanyByKeysAsync()),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetContract();
      return;
    }
    try {
      const company = await action();
      this.companyId = company.companyId;
      this.companyContract = company;
      await this.getAllLists('articles', 'conceptInvoicings');
      this.validateForm(this.companyContract);
      this.location.replaceState(`/${this.url}/register/${this.companyId}`);
    } catch (error) {
      console.error(`Error al buscar la compañia (${buttonClick.target.id}).`, error);
    }
  }

  openDeleteCompanyModal() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar compañías.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (!this.companyId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una compañía.');
      return;
    }
    this.updateInputsForDeleteCompanyModal();
    this.deleteCompanyModalComponent?.show();
  }

  openGeneralParameterModal() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para moficar los parámetros generales,
        comuniquese con el administrador del sistema.`);
      return;
    }
    if (!this.companyId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una compañia.');
      return;
    }
    this.updateInputsForGeneralParameterModal();
    this.generalParameterModalComponent?.show();
  }

  openPermissionsCompanyModal() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para moficar permisos,
        comuniquese con el administrador del sistema.`);
      return;
    }
    if (!this.companyId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una compañia.');
      return;
    }
    this.updateInputsForPermissionsCompanyModal();
    this.permissionsCompanyModalComponent?.show();
  }

  openMandatorModal() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para moficar mandantes,
        comuniquese con el administrador del sistema.`);
      return;
    }
    if (!this.companyId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una compañia.');
      return;
    }
    this.updateInputsForMandatorModal();
    this.mandatorModalComponent?.show();
  }

  openAdvancedOptions() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para moficar las opciones avanzadas,
        comuniquese con el administrador del sistema.`);
      return;
    }
    if (!this.companyId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una compañia.');
      return;
    }
    this.updateInputsForAdvancedOptionsModal();
    this.advancedOptionsModalComponent?.show();
  }

  resetContract() {
    this.companyId = 0;
    this.companyContract = new CompanyModel();
    this.validateForm(this.companyContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async userAuthenticatedIsASADMIN() {
    try {
      const response = await firstValueFrom(this.userService.userAuthenticatedIsASADMIN());
      this.isASADMIN = response;
    } catch (error) {
      console.error('Error al verificar si el usuario es ASADMIN.', error);
    }
  }

  async userAuthenticatedIsPrincipalCompany() {
    try {
      const response = await firstValueFrom(this.userService.userAuthenticatedIsPrincipalCompany());
      this.isPrincipalCompany = response;
    } catch (error) {
      console.error('Error al validar si la compañía es principal.', error);
    }
  }

  normalizeCompanyModel(modelcompany: CompanyModel): CompanyModel {
    if (modelcompany.alterCode === '') {
      modelcompany.alterCode = null;
    }
    if (modelcompany.accountingSystemId !== AccountingSystemEnums.helisa) {
      modelcompany.swHelissaNiif = false;
    }
    if (modelcompany.accountingSystemId !== AccountingSystemEnums.ilimitada) {
      modelcompany.swIlimitadaExchangeRate = false;
      modelcompany.swIlimitadaNewVersion = false;
      modelcompany.swIlimitadaNewPrefix = false;
    }
    return modelcompany;
  }

  async send() {
    this.validateFormControls();
    if (!this.formCompany.valid) {
      this.showValidationMessages();
      return;
    }
    let modelcompany = this.formCompany.getRawValue() as CompanyModel;
    if (modelcompany.typeAccountingSystemId != null && modelcompany.accountingSystemId == null) {
      this.toastHandlerService.showToast('warning', 'No ha seleccionado el sistema para el tipo de interfaz.');
      return;
    }
    modelcompany = this.normalizeCompanyModel(modelcompany);
    if (this.companyId == 0) {
      await this.createCompany(modelcompany);
    } else {
      await this.updateCompany(modelcompany);
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      code: {
        required: 'El campo Código es obligatorio.'
      },
      alterCode: {
        maxlength: 'El Código Alterno no puede tener más de 20 caracteres.'
      },
      name: {
        required: 'El campo Nombre es obligatorio.',
        maxlength: 'El Nombre no puede tener más de 100 caracteres.'
      },
      typeDocumentId: {
        required: 'Debe seleccionar un Tipo de Documento.',
        min: 'Debe seleccionar un Tipo de Documento válido.'
      },
      document: {
        required: 'El campo Documento es obligatorio.',
        maxlength: 'El Documento no puede tener más de 15 caracteres.'
      },
      digitVerification: {
        required: 'El Dígito de Verificación es obligatorio.',
        min: 'El dígito debe ser entre 0 y 9.',
        max: 'El dígito debe ser entre 0 y 9.'
      },
      deactivationDate: {
        required: 'Debe seleccionar una Fecha de Inactivación.'
      },
      invoiceExpirationDays: {
        required: 'Debe ingresar los Días de Vencimiento.',
        min: 'El número mínimo permitido es 1.',
        max: 'El número máximo permitido es 32767.'
      },
      activeUserAmount: {
        required: 'Debe ingresar la Cantidad de Usuarios Activos.'
      },
      openCutsAmount: {
        required: 'Debe ingresar la Cantidad de Cortes Abiertos.',
        min: 'El número de cortes permitidos es mínimo 1.',
        max: 'El número de cortes permitidos es máximo 10.'
      },
      openCashReceiptsAmount: {
        required: 'Debe ingresar la Cantidad de Recibos de Caja Abiertos.',
        min: 'El número de recibos permitidos es mínimo 1.',
        max: 'El número de recibos permitidos es máximo 10.'
      },
      accountingSystemLenght: {
        min: 'La longitud mínima permitida es 1.',
        max: 'La longitud máxima permitida es 20.'
      },
      ilimitadaTypeCree: {
        maxlength: 'El Tipo CREE no puede tener más de 2 caracteres.'
      },
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formCompany.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  reload(reload: boolean) {
    if (reload) {
      this.resetContract();
    }
  }

  updateFormState() {
    const { active, typeAccountingSystemId, accountingSystemId, companyId } = this.companyContract;
    this.disabledForm = !active;
    this.titleState = active ? 'Activar' : 'Inactivar';
    this.severityState = active ? 'success' : 'danger';
    this.stateCompany = active ? 'Activo' : 'Inactivo';
    this.icon = active ? 'pi pi-lock-open' : 'pi pi-lock';
    setTimeout(() => {
      const isAdminPrincipal = this.isASADMIN && this.isPrincipalCompany;
      const codeControl = this.formCompany.get('code');
      if (active && this.permissionUpdatable) {
        this.formCompany.enable();
        this.formCompany.get('digitVerification')?.disable();
        this.changeTypeAccountingSystem(typeAccountingSystemId, accountingSystemId);
        if (isAdminPrincipal) {
          companyId ? codeControl?.enable() : codeControl?.disable();
        } else {
          codeControl?.disable();
        }
        if (!this.isASADMIN) {
          this.formControlStateService.setControlState(this.formCompany, ['name', 'typeDocumentId',
            'document', 'typeAccountingSystemId', 'accountingSystemId', 'activeUserAmount'], false
          );
        }
      } else {
        this.formCompany.disable();
        if (isAdminPrincipal) {
          codeControl?.enable();
        }
      }
    });
  }

  updateInputsForDeleteCompanyModal() {
    this.inputsForDeleteCompanyModals$.next({
      companyId: this.companyId,
    });
  }

  updateInputsForGeneralParameterModal() {
    this.inputsForGeneralParameterModals$.next({
      companyId: this.companyId,
      disabledButton: this.disabledForm
    });
  }

  updateInputsForMandatorModal() {
    this.inputsForMandatorModals$.next({
      companyId: this.companyId,
      disabledForm: this.disabledForm
    });
  }


  updateInputsForPermissionsCompanyModal() {
    this.inputsForPermissionsCompanyModals$.next({
      companyId: this.companyId,
      disabledForm: this.disabledForm
    });
  }

  updateInputsForAdvancedOptionsModal() {
    this.inputsForAdvancedOptionsModals$.next({
      companyContract: this.companyContract,
      permissionUpdatable: this.permissionUpdatable,
      disabledForm: this.disabledForm,
      swAdvanceInvoice: this.swAdvanceInvoice,
      listArticles: this.listArticles,
      listConceptInvoicing: this.listConceptInvoicing,
      listCurrency: this.listCurrency,
      listCountry: this.listCountry,
    });
  }

  async updateCompany(modelcompany: CompanyModel) {
    this.companyContract.alterCode = modelcompany.alterCode;
    this.companyContract.name = modelcompany.name;
    this.companyContract.typeDocumentId = modelcompany.typeDocumentId;
    this.companyContract.document = modelcompany.document;
    this.companyContract.digitVerification = modelcompany.digitVerification;
    this.companyContract.deactivationDate = modelcompany.deactivationDate;
    this.companyContract.invoiceExpirationDays = modelcompany.invoiceExpirationDays;
    this.companyContract.accountingSystemId = modelcompany.accountingSystemId;
    this.companyContract.typeAccountingSystemId = modelcompany.typeAccountingSystemId;
    this.companyContract.activeUserAmount = modelcompany.activeUserAmount;
    this.companyContract.openCutsAmount = modelcompany.openCutsAmount;
    this.companyContract.openCashReceiptsAmount = modelcompany.openCashReceiptsAmount;
    this.companyContract.swHelissaNiif = modelcompany.swHelissaNiif;
    this.companyContract.accountingSystemLenght = modelcompany.accountingSystemLenght;
    this.companyContract.ilimitadaTypeCree = modelcompany.ilimitadaTypeCree;
    this.companyContract.swIlimitadaNewVersion = modelcompany.swIlimitadaNewVersion;
    this.companyContract.swIlimitadaNewPrefix = modelcompany.swIlimitadaNewPrefix;
    this.companyContract.swIlimitadaExchangeRate = modelcompany.swIlimitadaExchangeRate;
    this.companyContract.reteIvaRate = modelcompany.reteIvaRate;
    this.companyContract.creeRate = modelcompany.creeRate;
    this.companyContract.companySiesaId = modelcompany.companySiesaId;
    this.companyContract.systemSiesaId = modelcompany.systemSiesaId;
    this.companyContract.conniKeySiesa = modelcompany.conniKeySiesa;
    this.companyContract.conniTokenSiesa = modelcompany.conniTokenSiesa;
    this.companyContract.siesaBaseAddress = modelcompany.siesaBaseAddress;
    try {
      const response = await firstValueFrom(this.companyService.updateCompany(this.companyContract));
      this.companyContract = response;
      this.validateForm(this.companyContract);
      this.toastHandlerService.showToast('success', `La compañía fue modificada exitosamente.`);
    } catch (error) {
      console.error('Error al actualizar la compañía.', error);
    }
  }

  validateForm(company: CompanyModel) {
    this.formCompany = this.formBuilder.group({
      code: [company.code, [Validators.required]],
      alterCode: [company.alterCode, [Validators.maxLength(20)]],
      name: [company.name, [Validators.required, Validators.maxLength(100)]],
      typeDocumentId: [company.typeDocumentId, [Validators.required, Validators.min(1)]],
      document: [company.document, [Validators.required, Validators.maxLength(15)]],
      digitVerification: [company.digitVerification, [Validators.required, Validators.min(0), Validators.max(9)]],
      deactivationDate: [company.deactivationDate ? this.dateConverterService.convertDatePreserveDay(company.deactivationDate)
        : null, [Validators.required]],
      invoiceExpirationDays: [company.invoiceExpirationDays, [Validators.required, Validators.min(1), Validators.max(32767)]],
      accountingSystemId: [company.accountingSystemId],
      typeAccountingSystemId: [company.typeAccountingSystemId],
      activeUserAmount: [company.activeUserAmount, [Validators.required]],
      openCutsAmount: [company.openCutsAmount, [Validators.required, Validators.min(1), Validators.max(10)]],
      openCashReceiptsAmount: [company.openCashReceiptsAmount, [Validators.required, Validators.min(1), Validators.max(10)]],
      swHelissaNiif: [company.swHelissaNiif],
      accountingSystemLenght: [company.accountingSystemLenght, [Validators.min(1), Validators.max(20)]],
      creeRate: [company.creeRate],
      ilimitadaTypeCree: [company.ilimitadaTypeCree, [Validators.maxLength(2)]],
      swIlimitadaNewVersion: [company.swIlimitadaNewVersion],
      swIlimitadaNewPrefix: [company.swIlimitadaNewPrefix],
      swIlimitadaExchangeRate: [company.swIlimitadaExchangeRate],
      companySiesaId: [company.companySiesaId],
      systemSiesaId: [company.systemSiesaId],
      conniKeySiesa: [company.conniKeySiesa, [Validators.maxLength(50)]],
      conniTokenSiesa: [company.conniTokenSiesa, [Validators.maxLength(500)]],
      siesaBaseAddress: [company.siesaBaseAddress, [Validators.maxLength(500)]]
    });
    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formCompany.controls).forEach((key) => {
      const control = this.formCompany.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
